import Vue from 'vue'
import App from './App.vue'
import routes from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import mixin from './mixins/index'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'

Vue.use(VueRouter)

Vue.use(VueI18n)

Vue.mixin(mixin)
Vue.config.productionTip = false

// 多言語対応
export const i18n = new VueI18n({
  locale: 'cn',
  silentTranslationWarn: true,
  messages: {
    // 翻訳用のjson
    ja: require('@/lang/ja.json'),
    en: require('@/lang/en.json'),
    cn: require('@/lang/cn.json')
    // tw: require('../lang/tw.json')
  }
})

// axiosのデフォルト設定
// 他の設定を使用するAPIは適宜axiosをcreateする
// createだとインスタンスがコピーされるっぽい。。
axios.defaults.withCredentials = true
axios.defaults.xsrfCookieName = 'XSRF-TOKEN'
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.params = {}
export const router = new VueRouter({
  mode: 'history',
  routes
})

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
